import Service from "../AuthService";

const Item = {
    getItems() {
        return Service.get(`items`);
    },
    getSettingItem() {
        return Service.get(`settings/items`);
    },
    createSettingItem(payload, token) {
        return Service.post(`settings/items?token=${token}`, payload);
    },
    updateSettingItem(payload, id, token) {
        return Service.put(`settings/items/${id}?token=${token}`, payload);
    },
    deleteSettingItem(id, token) {
        return Service.delete(`settings/items/${id}?token=${token}`);
    }
};

export default Item;
